import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";
import CardAds from "../Card/CardAds";
import CardEvents from "../Card/CardEvents";
import CardQna from "../Card/CardQna";
import CardPrograms from "./CardPrograms/CardPrograms";
import MaterialEvents from "./MaterialEvents";
import { PremiumDialog } from "./PremiumDialog/PremiumDialog";
import WebinarTanyaAhli from "./TanyaAhli/WebinarTanyaAhli";
import {
  getAdditionalContent,
  getAdditionalProducts,
} from "../services/products";
import { useTranslation } from "react-i18next";

function MobileHome(props) {
  const {
    eventData,
    token,
    eventCode,
    setOpenLogin,
    material,
    schedule,
    setOpenTesti,
    setTestimoniItem,
    testimoniItem,
    qna,
    lengthQuiz,
    maindata,
    setQna,
    setTitleAudio,
    setAudioId,
    setIdl,
    adsData,
    dataFloatingAds,
    programs,
    isMobile,
    expired,
    memberType,
    name,
    setAskQuestion,
    setSpeaker,
    setAskExpert
  } = props;
  const [qnaFilter, setQnaFilter] = React.useState(null);
  const [premiumDialog, setPremiumDialog] = React.useState(false);
  const [content, setContent] = React.useState(false);
  const [products, setProducts] = React.useState(false);
  const [isEventPaid, setIsEventPaid] = React.useState(false);
  const enableScreening = eventData?.isScreening === "true";
  const { t } = useTranslation();

  React.useEffect(() => {
    if (!eventData || !eventData?.eventId || !isMobile) {
      return;
    }

    if (eventData?.isPaid === "true") {
      setIsEventPaid(true);
    }

    getAdditionalContent(eventData.eventId).then((d) => {
      setContent(d.data[0]);
    });

    getAdditionalProducts(eventData.eventId).then((d) => {
      const products = d.data?.sort((a, b) => {
        return a.normalPrice > b.normalPrice;
      });

      if (products) {
        setProducts(products[0]);
      }
    });
  }, [eventData, isMobile]);

  const MENUS = [
    {
      id: 0,
      name: "Webinar",
      imgKey: "menu-schedule",
      path: "/schedule",
    },
    {
      id: 1,
      name: "Survey",
      imgKey: "menu-survey",
      path: "/survey",
    },
    {
      id: 2,
      name: t("quiz"),
      imgKey: "menu-quiz",
      path: "/quiz",
    },
    {
      id: 3,
      name: "Video",
      imgKey: "menu-video",
      path: "/material/video",
    },
    {
      id: 4,
      name: t("modules"),
      imgKey: "menu-modul",
      path: "/material/modul",
    },
    {
      id: 5,
      name: t("article"),
      imgKey: "menu-artikel",
      path: "/article",
    },
  ];

  return (
    <React.Fragment>
      <div className="section-ones">
        {eventData.miniCover && (
          <img
            src={`https://fammi.ly/uploads/events/images/${
              eventData.miniCover
            }?v=${Math.random()}`}
            alt="cover"
            style={{
              width: "100%",
              height: 73,
              objectFit: "cover",
              borderRadius: "8px 8px 0px 0px",
            }}
          />
        )}
        <div
          className="mob-covers"
          style={{ borderRadius: eventData?.miniCover && "0px 0px 8px 8px" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: 12,
            }}
          >
            {eventData?.logo && (
              <img
                src={`https://fammi.ly/uploads/events/images/${eventData?.logo}`}
                alt="buildings"
                width="44px"
                height="44px"
                style={{
                  background: "#fff",
                  borderRadius: "50%",
                  border: "1px solid #eaeaea",
                }}
              />
            )}
            {!eventData?.logo && (
              <img src="/assets/images/e_buildings.svg" alt="buildings" />
            )}
            <div>
              <h4
                style={{
                  fontFamily: "'Rubik'",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "16px",
                  lineHeight: "19px",
                  color: "rgba(0, 0, 0, 0.87)",
                  marginLeft: 12,
                }}
              >
                {eventData?.name}
              </h4>
            </div>
          </div>
          {isEventPaid && !token && content && (
            <div className="microsite-paids">
              <div className="prime">
                <h1>{content?.title}</h1>
                <p>{content?.descriptions}</p>
                <div className="flexed">
                  <div>
                    <h5>Biaya Program</h5>
                    <h4>
                      Rp
                      {parseInt(products?.normalPrice).toLocaleString("ID-id")}
                      ,-
                    </h4>
                  </div>
                  <button
                    onClick={() => {
                      localStorage.setItem("c892072", `/e/${eventCode}/payment-package`);
                      setOpenLogin(true);
                    }}
                  >
                    <img
                      src="/assets/images/shield_check.svg"
                      alt="secure-checks"
                    />
                    Beli Sekarang
                  </button>
                </div>
              </div>
              <div className="bottomeds">
                <div className="flexed">
                  <img
                    style={{ marginRight: 10 }}
                    src="/assets/images/e_new_lock.svg"
                    alt="locks"
                  />
                  <p>Sudah beli program ini?</p>
                </div>
                <a
                  href="#"
                  onClick={() => {
                    localStorage.setItem("c892072", `/e/${eventCode}/payment-package`);
                    if (setIdl) {
                      setIdl(1);
                    }
                    setOpenLogin(true);
                  }}
                >
                  Masuk Sekarang
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="menu">
        {MENUS.map((m) => (
          <div
            key={m.id}
            onClick={async () => {
              props.history.push(`/e/${eventCode}${m.path}`);
            }}
          >
            <div
              style={{
                background: "#F5F5F5",
                height: 38,
                width: 38,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                marginBottom: 8,
              }}
            >
              <img src={`/assets/images/${m.imgKey}.svg`} alt={m.name} />
            </div>
            <p>{m.name}</p>
          </div>
        ))}
      </div>
      {!token && !isEventPaid ? (
        <div className="logins-mob">
          <button
            onClick={() => {
              if (eventCode === "orangtuaberpijar") {
                window.location.href = process.env.REACT_APP_PIJAR_LOGIN_PAGE;
                return;
              }
              setIdl(1);
              setOpenLogin(true);
            }}
            className="msk"
          >
            {t("login")}
          </button>
          <button
            onClick={() => {
              if (eventCode === "orangtuaberpijar") {
                window.location.href =
                  process.env.REACT_APP_PIJAR_REGISTER_PAGE;
                return;
              }
              setIdl(0);
              setOpenLogin(true);
            }}
            className="dft"
          >
            {t("sign-up")}
          </button>
        </div>
      ) : (
        ""
      )}

      <div className="last-event">
        {isMobile && (
          <WebinarTanyaAhli
            eventData={eventData}
            name={name}
            setAskQuestion={setAskQuestion}
            setSpeaker={setSpeaker}
            setOpenLogin={setOpenLogin}
            setAskExpert={setAskExpert}
          />
        )}

        {qna.length > 0 && (
          <div style={{ padding: 0, marginTop: 32 }} className="qna">
            <div className="head-section">
              <h1>{t("question-answer")}</h1>
              <button
                onClick={() => {
                  if (expired) return setPremiumDialog(true);

                  if (token && token !== null) {
                    props.history.push(`/e/${eventCode}/qna`);
                    return;
                  }
                  setOpenLogin(true);
                }}
                className="look-all"
              >
                {t("see-all")}
              </button>
            </div>
            {qna?.slice(0, 2).map((item, index) => (
              <CardQna
                data={item}
                key={index}
                eventCode={eventCode}
                audioId={item?.audioId ?? null}
                setTitleAudio={setTitleAudio}
                setAudioId={(id) => {
                  setAudioId(null);
                  setTimeout(() => {
                    setAudioId(id);
                  }, 100);
                }}
                setOpenLogin={setOpenLogin}
              />
            ))}
          </div>
        )}

        {programs && (
          <div className="head-section">
            <h1>{t("learn-practices")}</h1>
            {/* <div>
              <p>Hanya {programs?.duration}</p>
            </div> */}
            {programs && (
              <button
                className="look-all"
                onClick={() => {
                  if (token && token !== null) {
                    props.history.push(`/e/${eventCode}/programs`);
                    return;
                  }
                  setOpenLogin(true);
                }}
              >
                {t("see-all")}
              </button>
            )}
          </div>
        )}
        {programs && (
          <CardPrograms
            programs={programs}
            materi={true}
            eventData={eventData}
          />
        )}
      </div>
      <div className="materials-mobile">
        {material?.length || lengthQuiz > 0 ? (
          <MaterialEvents
            length={material?.length}
            setOpenLogin={setOpenLogin}
            push={() => props.history.push(`/e/${eventCode}/materials_event`)}
            pushQuiz={() => props.history.push(`/e/${eventCode}/quiz`)}
            lengthQuiz={lengthQuiz}
          />
        ) : (
          ""
        )}
      </div>
      <div
        className="lists-mobile"
        style={{ marginBottom: 20, padding: "0 16px" }}
      >
        {adsData && <CardAds eventCode={eventCode} data={adsData} />}
        {dataFloatingAds && (
          <CardAds eventCode={eventCode} data={dataFloatingAds} />
        )}
      </div>
      {schedule?.length > 0 && (
        <div className="last-event">
          <div className="head-section">
            <h1>Webinar</h1>
            <button
              onClick={() => {
                if (token && token !== null) {
                  props.history.push(`/e/${eventCode}/schedule`);
                  return;
                }
                setOpenLogin(true);
              }}
              className="look-all"
            >
              {t("see-all")}
            </button>
          </div>
          {schedule
            ?.slice(schedule?.length - 1, schedule?.length)
            ?.map((item, index) => (
              <CardEvents
                setOpenLogin={setOpenLogin}
                data={item}
                eventCode={eventCode}
                key={index}
                setOpenTesti={setOpenTesti}
                setTestimoniItem={setTestimoniItem}
                testimoniItem={testimoniItem}
                getTestimonials={(scheduleId) => {
                  window.location.href =
                    "/e/" + eventCode + "/schedule/" + scheduleId;
                }}
              />
            ))}
          <button
            onClick={() => {
              if (token && token !== null) {
                props.history.push(`/e/${eventCode}/schedule`);
                return;
              }
              setOpenLogin(true);
            }}
            className="look-all"
          >
            Lihat Semua Webinar
          </button>
        </div>
      )}
      {premiumDialog && (
        <PremiumDialog
          endDate={eventData?.endDate}
          onClose={() => setPremiumDialog(false)}
          history={props.history}
          eventCode={eventCode}
          expired={expired}
        />
      )}
    </React.Fragment>
  );
}

export default withRouter(MobileHome);
